import React from 'react'

import { Video } from '../../../../api/videos/types'
import VideoGrid from '../../../components/content/VideoGrid'

interface VideosGridProps {
  queryFn: () => { data: Video[] | null | undefined, isLoading: boolean, error: Error | null }
}

const VideosGrid: React.FC<VideosGridProps> = ({ queryFn }) => {
  const { data, isLoading, error } = queryFn()

  return <VideoGrid data={data} isLoading={isLoading} error={error} />
}

export default VideosGrid
